(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'AnagraficaService'];

    function UserManagementDetailController($stateParams, AnagraficaService) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.userId);

        function load(userId) {
        	AnagraficaService.strutturato.getOne({userId : $stateParams.userId}, function(result){
        		vm.user = result;
        		if(vm.user.aliasPosta!=null && vm.user.aliasPosta.length>0){
                	vm.mailAliases = vm.user.aliasPosta.split(";");
                }

        	});
           
        }
    }
})();
